import { useEffect, useState } from 'react';
import { setLoginSuccess } from '../../store/actions/reduxAction';
import { useSelector, useDispatch } from 'react-redux'
import config from '../../config/Constant';
import { postRequestWithoutAccessToken } from '../../helpers/apiHandler';
import { useNavigate } from 'react-router-dom';
import CustomAlert from '../../components/CustomAlert';

const LoginWithGoogle = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const handleGoogleAuth = (response) => {
    if (response) {
      setAlertState({
        show: true,
        variant: 'success',
        message: 'You have successfully logged in with your Google account!',
      });
    }
    const google_token = response?.credential;

    const data = {
      social_platform: config.social_login_platforms.google,
      token: google_token,
    };
    postRequestWithoutAccessToken('/auth/social-login', data, (res) => {
      if (res.success) {
        dispatch(setLoginSuccess(res));
        const { phone_active, active, access_token } = res.data;

        if (active && phone_active) return navigate('/dashboard');
        if (!active) return navigate(`/email/verify/${access_token?.token}`);
        if (!phone_active && active) return navigate(`/phone/verify/${access_token?.token}`);
      }
      if (res.error) {
        console.error(response.error);
        setAlertState({
          show: true,
          message: res.message,
          variant: 'danger',
        });
      }
    });
  };

  useEffect(() => {
    window.onGoogleSuccess = (response) => {
      handleGoogleAuth(response);
    };

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // clean up for react lifecycle
      window.onGoogleSuccess = undefined;
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div
        id="g_id_onload"
        data-client_id="692091235262-qs5cbqihi6e8ojisa35itfnomul4ft0l.apps.googleusercontent.com"
        data-context="signup"
        data-ux_mode="popup"
        data-callback="onGoogleSuccess"
        data-auto_prompt="false"
      />

      <div
        className="g_id_signin"
        data-type="standard"
        data-shape="pill"
        data-theme="outline"
        data-text="signup_with"
        data-size="large"
        data-logo_alignment="left"
      />

      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
    </>
  );
};

export default LoginWithGoogle;
